import React from 'react';
import { CheckCircleIcon } from '@heroicons/react/24/outline';

export default function ProfileSuccessMessage({ show, message = "Profile updated successfully!" }) {
  if (!show) return null;

  return (
    <div className="fixed top-4 right-4 z-50 animate-fade-in">
      <div className="bg-green-50 border border-green-200 rounded-lg p-4 shadow-lg flex items-center gap-3">
        <CheckCircleIcon className="h-6 w-6 text-green-600" />
        <span className="text-green-800 font-medium">{message}</span>
      </div>
    </div>
  );
}
